import { AskDialog, Icon, type ConfirmationTone } from 'admination-react'

export type AskModalProps = {
  open: boolean
  icon: string
  iconStroke?: boolean
  variant: 'is-info' | 'is-warning' | 'is-success' | 'is-error'
  question: string
  description?: React.ReactNode
  confirmLabel: string

  cancelLabel: string

  cancelButton?: boolean
  busy?: boolean
  onConfirm: () => void
  onCancel: () => void
  onDismiss?: () => void
}

const TONE: Record<AskModalProps['variant'], ConfirmationTone> = {
  'is-info': 'info',
  'is-warning': 'warning',
  'is-success': 'success',
  'is-error': 'error',
}

const STROKE_ICON_PROPS = {
  width: 16,
  height: 16,
  viewBox: '0 0 20 20',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} as const

export function AskModal({
  open,
  icon,
  iconStroke,
  variant,
  question,
  description,
  confirmLabel,
  cancelLabel,
  cancelButton,
  busy,
  onConfirm,
  onCancel,
  onDismiss,
}: AskModalProps) {
  if (!open) return null

  const destructive = variant === 'is-error'

  return (
    <AskDialog
      tone={TONE[variant]}
      icon={<Icon name={icon} {...(iconStroke ? STROKE_ICON_PROPS : {})} />}
      title={question}
      confirmLabel={
        <>
          <Icon name={destructive ? 'i-trash' : 'i-check'} />
          {confirmLabel}
        </>
      }
      cancelLabel={cancelLabel}
      cornerDismiss={!cancelButton && !onDismiss}
      headingLevel="h2"
      busy={busy}
      danger={destructive}
      onDismiss={onDismiss}
      onDecide={(confirmed) => {

        if (confirmed) onConfirm()
        else onCancel()
      }}
    >
      {description}
    </AskDialog>
  )
}
